import { Link } from "react-router-dom";
import { faCodeBranch } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Stack, Text } from "@mantine/core";

import { useBasePath } from "@hooks";

export const SetUpCIUpsell: React.FC<{ toTrackItemName: string }> = ({
  toTrackItemName,
}) => {
  const basePath = useBasePath();
  return (
    <Stack align="center">
      <Text align="center">{`Enable CI to track ${toTrackItemName}!`}</Text>
      <Button
        size="md"
        component={Link}
        leftIcon={<FontAwesomeIcon icon={faCodeBranch} />}
        to={`${basePath}/projects?ci=true`}
        color="violet"
      >
        Set up CI
      </Button>
      <Text
        sx={{ "&:hover": { textDecoration: "underline" } }}
        size="sm"
        component="a"
        href={"https://semgrep.dev/docs/semgrep-ci/overview/"}
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more
      </Text>
    </Stack>
  );
};
